var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 164,
    viewBox: "0 0 314 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75169 3.88614L37.8681 44.0176C41.9737 48.8471 49.1275 49.6505 54.202 45.8519L72.2953 32.3081L102.134 11.1789C107.55 7.34352 115.051 8.63291 118.876 14.0568L120.963 17.0165C122.418 19.0805 124.488 20.6327 126.876 21.452L148.328 28.8098C150.477 29.5468 152.791 29.6588 155 29.1328L171.851 25.1221C176.414 24.0361 181.191 25.708 184.081 29.4023L209.193 61.5031L259.805 130.941L275.443 154.799C278.885 160.051 285.795 161.76 291.289 158.72L310.253 148.225",
    stroke: "#E52823",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRoute);
export default __webpack_public_path__ + "static/media/map-route.74135ef093a6977a074a4927720391c5.svg";
export { ForwardRef as ReactComponent };